<template>
  <div>
    <server-error :error="error" />
    <div class="b-full-table">
      <div class="b-full-table__row b-full-table__row-header">
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_date"
             :class="tableHeaderClass('convertedDate')" @click="sortEventsByKey('convertedDate')"
        >
          {{ $t('CONTENT.events.event_date') }}
        </div>
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_date">
          {{ $t('CONTENT.events.lat_event_date') }}
        </div>
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_type">
          {{ $t('CONTENT.events.event_type') }}
        </div>
        <div class="b-full-table__cell b-full-table__cell_event_date b-full-table__header-cell ">
          {{ $t('CONTENT.events.event_document_date') }}
        </div>
        <div class="b-full-table__cell b-full-table__cell_event_number b-full-table__header-cell">
          {{ $t('CONTENT.events.event_number') }}
        </div>
        <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.events.event_comment') }}</div>
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__cell_type_btn"></div>

      </div>
      <template v-for="(version) in sortedEvents">
        <div class="b-table__row b-full-table__row" :key="version.idInDB">
          <div class="b-full-table__cell b-full-table__cell_event_date"
               @click="clickedOnVersion(version.contractId, version.idInDB)"
          >
            {{ version.convertedDate }}
            <span v-if="version.isCurrent">
              ({{ $t('CONTENT.contract.current_contract') }})
            </span>
          </div>
          <div class="b-full-table__cell b-full-table__cell_event_date">
            {{ version.convertedCreatedDate }}
          </div>
          <div class="b-full-table__cell b-full-table__cell_event_type">
            {{ version.translatedEventType }}
            <br/>
            <ul>
              <li v-for="command in version.commands" :key="command.idInDB">
                <span>— {{ $t(`CONTENT.events.${command.commandName}`) }}. </span>
                <template v-for="(assetDetail, index) in commandDetails(command)">
                  <span v-if="assetDetail.assetName !== undefined">{{ assetDetail.assetName }}. </span>
                  <span v-if="assetDetail.externalId !== undefined" class="external-id">
                    {{ $t('CONTENT.assets.externalId') }}: {{ assetDetail.externalId }}.</span>
                </template>
              </li>

            </ul>
            <div v-if="version.isIntegrationEvent" class="mt-1 ml-2">
              <span class="b-full-table__annotation">{{ $t('CONTENT.events.version_annotation') }}</span>
            </div>
          </div>
          <div class="b-full-table__cell b-full-table__cell_event_date">
            <input
              id="document-date"
              v-model.lazy="version.documentDate"
              data-cy="document-date"
              type="text"
              class="b-input"
              name="document-date"
              @change="changeNumberOrCommentForVersion(version)"
            />
          </div>
          <div class="b-full-table__cell b-full-table__cell_event_number">
            <input
              id="number"
              v-model.lazy="version.number"
              data-cy="event-number"
              type="text"
              class="b-input"
              name="event-number"
              @change="changeNumberOrCommentForVersion(version)"
            />
          </div>
          <div class="b-full-table__cell">
            <textarea
              id="event-comment"
              v-model.lazy="version.comments"
              data-cy="event-comment"
              style="width: 300px; height: 100px;"
              type="text"
              class="b-input"
              name="event-comment"
              @change="changeNumberOrCommentForVersion(version)"
            />
          </div>
          <div class="b-full-table__cell b-full-table__cell_type_btn">
            <button
              v-if="!isReadOnlyMode && eventIndex(version) === convertedEvents.length - 1 && version.eventType !== 'initial_recognition'"
              type="button" class="b-btn pl-4 pr-4" @click="rollBackLastEvent(version.idInDB)"
              :disabled="eventDateIsInClosedPeriod(version)"
            >{{ $t('CONTENT.events.rollback') }}
            </button>
            <button
              v-if="!isReadOnlyMode && eventIndex(version) === convertedEvents.length - 1 && version.eventType !== 'initial_recognition' && !version.isIntegrationEvent"
              type="button" class="b-btn pl-4 pr-4 ml-4" @click="onRemoveEventClick(version)"
              :disabled="eventDateIsInClosedPeriod(version)"
            >{{ $t('CONTENT.events.delete_event') }}
            </button>
          </div>
        </div>
      </template>
    </div>
    <confirmation-modal ref="confirmationModal"/>
  </div>
</template>
<script>
import lodash from 'lodash';
import dateConverter from '../../../../utils/converters/date.converter';
import EventRegistryAPI from '../../../../api/EventRegistryAPI';
import ContractEventsMixin from './ContractEventsMixin';
import { mapGetters } from 'vuex';
import DateConverter from '../../../../utils/converters/date.converter';
import PaymentsCalculationsAPI from "@/plugins/paymentCalculations/api/PaymentsCalculationsAPI";

export default {
  mixins: [ContractEventsMixin],
  props: {
    contractId: {
      required: true,
      type: Number | String
    }
  },
  data() {
    return {
      events: null,
      currentContactId: null,
      localStoragePrefix: 'contract_versions_',
      currentContract: null,
      allVersions: [],
      error: null,
      role: null,
      isReadOnlyMode: true,
    };
  },
  async created() {
    this.$fileLoadingManager.startLoading();
    this.currentContract = _.cloneDeep(this.getCurrentContract);
    await this.$eventRegistryManager.loadContractVersions(this.contractId);
    const api = new PaymentsCalculationsAPI();
    this.allVersions = await api.getContractVersions(this.contractId);
    this.role = localStorage.getItem('role');
    if (this.role === 'Admin' || this.role === 'Operator') {
      this.isReadOnlyMode = false;
    }
    this.$fileLoadingManager.finishLoading();
  },
  computed: {
    ...mapGetters(['getAssets', 'getContractAssetComponents', 'getContractSettings', 'getCurrentContract']),
    convertedEvents() {
      this.events = this.$store.state.eventRegistryPlugin.directoryEvents;
      let convertedArray = [];
      for (let i = 0; i < this.events.length; i++) {
        const element = this.events[i];
        const clone = lodash.clone(element);
        clone.convertedDate = this.$d(dateConverter.convertToDate(clone.eventDate));
        if (clone.createEventDate) {
          clone.convertedCreatedDate = this.$d(dateConverter.convertToDate(clone.createEventDate));
        }
        clone.isCurrent = this.$route.query.eventId == clone.idInDB;
        clone.translatedEventType = this.$t(`CONTENT.events.${clone.eventType}`);
        convertedArray.push(clone);
      }
      return convertedArray;
    },
  },
  methods: {
    clickedOnVersion(id, eventId) {
      this.$emit('clickedOnVersion', {
        id: id,
        eventId: eventId
      });
    },
    changeNumberOrCommentForVersion(version) {
      const data = {
        idInDb: version.idInDB,
        number: version.number,
        comments: version.comments,
        documentDate: version.documentDate,
      };
      const index = this.events.findIndex(e => e.idInDB === version.idInDB);
      this.events[index] = version;
      new EventRegistryAPI().updateNumberAndComments(data);
    },
    onRemoveEventClick(version) {
      this.$refs.confirmationModal.show({
        onOk: () => this.removeLastEvent(version.idInDB),
        message: `${this.$t('CONTENT.events.delete_event_confirmation_message')} ${version.convertedDate}?`
      });
    },
    async removeLastEvent(eventId) {
      try {
        await this.$store.dispatch('eventRegistryPlugin/removeLastEvent', eventId)
        await this.$eventRegistryManager.loadContractVersions(this.contractId);
      } catch(e){
        this.error = e;
        this.onException(e);
        return
      }

      this.$toast.success(this.$t('NOTIFY.event_deleted'));
      this.$parent.$emit('updateCurrentContract');
    },
    onException(e) {
      let message = this.$t('ERRORS.UnknownError')

      if(e.response === undefined) {
        message = this.$t('ERRORS.NetworkError')
      } else {
        const status = e.response.status
        if(status === 400) message = e.response.data.exceptions[0].message
        if(status === 500) message = this.$t('ERRORS.SystemError')
      }

      this.$toast.error(message);
    },
    async rollBackLastEvent(eventId) {
      try {
        await this.$store.dispatch('eventRegistryPlugin/rollbackLastEvent', eventId);
        await this.$eventRegistryManager.loadContractVersions(this.contractId);
      } catch (e) {
        this.error = e;
        this.onException(e)
        return
      }

      this.$toast.success(this.$t('NOTIFY.event_rolled_back'));
      this.$parent.$emit('updateCurrentContract');
    },
    commandDetails(command) {
      const commandData = JSON.parse(command.serialisedCommand);

      let assets = [];

      if (commandData.AssetId !== undefined) {
        const asset = this.getAssets.find(a => a.idInDB === commandData.AssetId);
        if (asset) assets.push({assetName: asset.name, externalId: asset.externalId});
      } else if (commandData.AssetComponentId !== undefined) {
        const asset = this.getContractAssetComponents[commandData.AssetComponentId];
        if (asset) assets.push({assetName: asset.name, externalId: asset.externalId});
      } else if (commandData.LessorComponentShareId !== undefined) {

        this.currentContract.assetComponents.forEach(assetComponent => {
          assetComponent.lessorComponentShares.forEach(lessorComponentShare => {
            //console.log("lessorComponentShare.idInDB: " + lessorComponentShare.idInDB); console.log("LessorComponentShareId: " + commandData.LessorComponentShareId);
            if (lessorComponentShare.idInDB === commandData.LessorComponentShareId) {
              assets.push({assetName: assetComponent.name, externalId: assetComponent.externalId});
            }
          });
        });
      } else if (commandData.PaymentParametersId !== undefined || commandData.PaymentId !== undefined) {
        this.currentContract.assetComponents.forEach(assetComponent => {
          assetComponent.lessorComponentShares.forEach(lessorComponentShare => {
            lessorComponentShare.paymentsParameters.forEach(paymentParameter => {
              if (paymentParameter.idInDB === commandData.PaymentParametersId || paymentParameter.idInDB === commandData.PaymentId) {
                assets.push({assetName: assetComponent.name, externalId: assetComponent.externalId});
              }
            });
          });
        });
      } else if (commandData.NewLessorComponentShares !== undefined) {
        const filteredAssetComponents = this.currentContract.assetComponents.filter(assetComponent => {
          return commandData.NewLessorComponentShares.some(item => item.AssetComponentId === assetComponent.idInDB)
        });
        filteredAssetComponents.forEach(x => assets.push({assetName: x.name, externalId: x.externalId}));

      } else if (commandData.ChangedLessorsIds !== undefined) {
        const filteredAssetComponents = this.currentContract.assetComponents.filter(assetComponent => {
          return commandData.ChangedLessorsIds.some(item => item.AssetComponentId === assetComponent.idInDB)
        });
        filteredAssetComponents.forEach(x => assets.push({assetName: x.name, externalId: x.externalId}));

      } else if (commandData.RemovedLessorId !== undefined && this.allVersions.length !== 0) {
        const curentDirectoryEvent = this.events.find(event => event.commands.some(commandItem => commandItem === command));
        const preLastVersionAssetComponents = this.allVersions.find(v=>v.versionId === curentDirectoryEvent.idInDB);
        if (preLastVersionAssetComponents && preLastVersionAssetComponents.assetComponentLessors) {
          preLastVersionAssetComponents.assetComponentLessors.forEach(ac => {
            if (ac.lessorIds && ac.lessorIds.some(lessorId => commandData.RemovedLessorId === lessorId)) {
              assets.push({ assetName: ac.assetComponentName, externalId: ac.assetComponentExternalId });
            }
          });
        }
      }
      return assets;
    },
    eventDateIsInClosedPeriod(event) {
      return false;
      if (this.getContractSettings.lastClosePeriodDate === '') return false
      const createEventDate = DateConverter.convertToDate(event.createEventDate)
      const lastClosePeriodDate = DateConverter.convertToDate(this.getContractSettings.lastClosePeriodDate)
      return createEventDate <= lastClosePeriodDate
    }
  },
};
</script>

<style scoped>
.external-id {
  color: #7d7d7d;
}
</style>
